import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Paper,
} from "@material-ui/core";
import { addMascaraReal } from "../../helper/utils";

const headRows = [
  {
    id: "NumeroDam",
    numeric: false,
    disablePadding: false,
    label: "Numero Dam",
  },
  {
    id: "DataSolicitacao",
    numeric: false,
    disablePadding: true,
    label: "Data de Emissão",
  },
  {
    id: "DataVencimento",
    numeric: false,
    disablePadding: true,
    label: "Data de Vencimento",
  },
  { id: "Inscricao", numeric: false, disablePadding: true, label: "Contribuinte" },
  { id: "Operacao", numeric: false, disablePadding: true, label: "Operação" },
  { id: "Valor", numeric: false, disablePadding: false, label: "Valor", align: 'right' },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headRows.map((row) => (
          <TableCell
            className="table-cell-style"
            key={row.id}
            align={row.align || "left"}
            padding={row.disablePadding ? "none" : "default"}
            sortDirection={orderBy === row.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === row.id}
              direction={order}
              onClick={createSortHandler(row.id)}
            >
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  // numSelected: PropTypes.number.isRequired,
  // onSelectAllClick: PropTypes.func.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    width: "100%",
    minWidth: 750,
  },
  tableWrapper: {
    display: 'flex',
    justifyContent: 'center',
    overflowX: "auto",
  },
  editIcon: {
    cursor: "pointer",
  },
  scaledUpRow: {
    cursor: "pointer",
    "&:hover": {
      transform: "scale(1.01)",
      background: "#f5f5f5",
    },
  },
}));

export default function EnhancedTable(props) {
  const classes = useStyles();

  const {
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    totalRecords,
    totalPages,
    damsList,
    consultarDam,
    getSortedDAMs,
    order,
    orderBy
  } = props;

  function handleRequestSort(event, property) {
    const isDesc = orderBy === property && order === "Desc";
    const sortDirection = isDesc ? "Asc" : "Desc"; 

    getSortedDAMs(sortDirection, property)
  }

  function handleClick(event, id) {
    let dam = damsList.filter((x) => x.IdDam === id)[0];

    consultarDam(dam);
  }

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <div className={classes.tableWrapper}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={"medium"}
          >
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={totalRecords}
            />
            <TableBody>
              {damsList?.map(
                (row, index) => {
                  return (
                    <TableRow
                      className={classes.scaledUpRow}
                      role="checkbox"
                      tabIndex={-1}
                      key={row.IdDam}
                      onClick={(event) => handleClick(event, row.IdDam)}
                    >
                      <TableCell align="left">{row.NumeroDam} </TableCell>
                      <TableCell align="left">{row.DataSolicitacao} </TableCell>
                      <TableCell align="left">{row.DataVencimento} </TableCell>
                      <TableCell align="left">{row.Inscricao} </TableCell>
                      <TableCell align="left">{row.Operacao} </TableCell>
                      <TableCell align="right">{addMascaraReal(row.Valor)} </TableCell>
                    </TableRow>
                  );
                }
              )}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRecords}
          rowsPerPage={rowsPerPage}
          page={page}
          labelRowsPerPage={"Linhas por página:"}
          labelDisplayedRows={() => {
            const pageLength = rowsPerPage * page;
            const to = Math.min(pageLength, totalRecords);
            const from = Math.min(pageLength - rowsPerPage + 1, to);

            return `${from}-${to} de ${totalRecords}`;
          }}
          backIconButtonProps={{
            "aria-label": "Anterior",
            disabled: page === 1,
          }}
          nextIconButtonProps={{
            "aria-label": "Próximo",
            disabled: page === totalPages,
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
